var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass:
      "c-file-browser__item d-flex justify-content-center align-items-center w-100 content",
    class: { "small-icon": _vm.smallIcon, "h-100": !_vm.isFolderItem },
    domProps: { innerHTML: _vm._s(_vm.itemSvg) },
    on: { mouseenter: _vm.onMouseEnter, mouseleave: _vm.onMouseLeave },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }